export enum casinoListEnum {
  LOTC = 'lotc',
  EUREKA = 'eureka',
  RWC = 'rwc',
  SLOTCHECK = 'slotcheck',
  ACH = 'ach',
  SSC = 'silversevens',
}

export enum casinoIdListEnum {
  LOTC = 1,
  EUREKA = 2,
  RWC = 3,
  SSC = 22,
  ACH = 23,
  JJC = 24,
  SLOTCHECK = 4,
}

export enum playerTypeEnum {
  slotCheckPlus = 'SlotCheckPlus',
  slotCheckPro = 'SlotPro',
  slotCheck = 'SlotCheck',
}

/** Display name for private / non-public accounts on leaderboards. */
export const PRIVATE_LEADERBOARD_PLAYER_NAME = 'Slot Check player';

export enum playerLevel {
  slotCheckPro = 2,
  slotCheck = 1,
}

export type playerType = keyof typeof playerTypeEnum;
export type casinoList = keyof typeof casinoListEnum;
export type casinoIdList = keyof typeof casinoIdListEnum;
